import React, { useEffect, useState } from 'react';
import { object, bool, string } from 'prop-types';
import { generateNewLanguageUrl } from '../../utils/localization';
import { initializeOptimizelyWithKey } from '../../utils/optimizely_helpers';
import NavigatorModal from '../NavigatorModal';

const GlobalActions = ({ currentUser, proUser, optimizelyKey, languageRegionCode, userLang, branchKey, mobileBrowser }) => {
  const [children, setChildren] = useState([]);

  const setUpTatari = () => {
    if (currentUser && window.tatari) {
      // Safety first - Wrap anything Tatari-related in a try/catch
      try {
        window.tatari.identify(currentUser.id);
      } catch (e) {
        window.Bugsnag.notify(e);
      }
    }
  };

  // In testing the pendo script tag has been slow to load so we
  // attempt up to 4 times every 750 ms to initialize the user.
  let pendoSetUpAttempts = 0;
  const maxPendoSetUpAttempts = 3;
  const pendoSetUpBackOff = 750;

  const setUpPendo = () => {
    if (!currentUser || pendoSetUpAttempts > maxPendoSetUpAttempts) {
      return;
    }

    if (window.pendo) {
      try {
        const visitor = {
          id: currentUser.id,
          pro: proUser
        };
        window.pendo.initialize({ visitor });
      } catch (e) {
        window.Bugsnag.notify(e);
      }
    } else {
      pendoSetUpAttempts += 1;
      setTimeout(setUpPendo, pendoSetUpBackOff);
    }
  };

  const setUpOptimizely = () => {
    try {
      if (optimizelyKey) {
        initializeOptimizelyWithKey(optimizelyKey);
      }
    } catch (e) {
      window.Bugsnag.notify(e);
    }
  };

  const getCurrentLanguage = () => {
    let language = '/en';
    if (languageRegionCode) {
      const path_language_regex = languageRegionCode.substring(0, 2).match(/(es|fr|de)/);
      if (Array.isArray(path_language_regex)) {
        language = `/${path_language_regex[0]}`;
      }
    }
    return language;
  };

  const redirectToProperLanguage = newLanguage => {
    if (window) {
      window.location = generateNewLanguageUrl(window.location.pathname, newLanguage);
    }
  };

  const showNavigatorModal = () => {
    if (!branchKey) {
      return;
    }

    const navigatorMessageParam = 'navigator_desktop';
    const searchParams = new URLSearchParams(window.location.search);

    if (!searchParams.has(navigatorMessageParam)) {
      return;
    }

    setChildren([...children, <NavigatorModal branchKey={branchKey} languageRegionCode={languageRegionCode} mobileBrowser={mobileBrowser} />]);
  };

  useEffect(() => {
    // TODO: Move this redirect logic to the controller
    const currentLanguage = getCurrentLanguage();

    if (currentLanguage && userLang && currentLanguage !== userLang) {
      redirectToProperLanguage(userLang);
    }
  }, []);

  useEffect(() => {
    setUpTatari();
  }, []);

  useEffect(() => {
    setUpPendo();
  }, []);

  useEffect(() => {
    setUpOptimizely();
  }, []);

  useEffect(() => {
    showNavigatorModal();
  }, []);

  return <>{children}</>;
};

GlobalActions.propTypes = {
  branchKey: string,
  currentUser: object,
  languageRegionCode: string,
  proUser: bool, // can be logged out
  userLang: string
};

GlobalActions.defaultProps = {
  branchKey: null,
  currentUser: null,
  languageRegionCode: 'en-US',
  proUser: null,
  userLang: '/en'
};

export default GlobalActions;
